import { useContext } from 'react'
import { PanelStackContext, type PanelStackValue } from '../components/panelStackContextObject'

export function usePanelStack(): PanelStackValue {
  const ctx = useContext(PanelStackContext)
  if (!ctx) {
    throw new Error('usePanelStack must be used within a PanelStackProvider')
  }
  return ctx
}
